import { render, staticRenderFns } from "./StopCampaignModal.vue?vue&type=template&id=05ff0fb9&lang=pug"
import script from "./StopCampaignModal.vue?vue&type=script&lang=js"
export * from "./StopCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports